import signup from "skin/entry/query/signup";
import useReferral from "skin/entry/hook/referral";
import useFormInput from "./input";
import useInnLookup from "./inn";
import { useState } from "react";

export default function useSignup() {
	const code = useReferral('ref_client');
	const [wait, setWait] = useState(false);
	const innState = useInnLookup();

	let { value, handlers, err, setErr, addressState } = useFormInput();
	value = { ...value, address: addressState.value, inn: innState.value };
	handlers = { ...handlers, address: addressState.onChange, inn: innState.onChange };
	err = { ...err, address: addressState.err, inn: innState.err };

	return { wait, submit, value, handlers, err, addressState, innState };

	function check() {
		let ok = true;
		if (!innState.cmp) { ok = false; innState.setErr('Введите ИНН'); }
		else if (innState.cmp.type === 'INDIVIDUAL' && !addressState.value) { ok = false; addressState.setErr('Введите адрес'); }
		if (!value.source) { ok = false; setErr.source('Выберите источник'); }
		if (!value.login) { ok = false; setErr.login('Введите логин'); }
		if (!value.password) { ok = false; setErr.password('Введите пароль'); }
		if (!value.password2) { ok = false; setErr.password2('Повторите пароль'); }
		else if (value.password && value.password !== value.password2) { ok = false; setErr.password2('Пароли не совпадают'); }
		if (!value.phone) { ok = false; setErr.phone('Укажите и подтвердите номер телефона'); }
		return ok;
	}

	function submit() {
		const ok = check();
		if (!ok) return;
		setWait(true);
		signup({
			login: value.login,
			password: value.password,
			password2: value.password2,
			phone: value.phone,
			where: value.source,
			company: { ...innState.cmp, type: 'company', address: addressState.value },
			ref: code
		})
			.catch(e => {
				alert('Ошибка при создании учётной записи: ' + e.toString())
				console.error('err', e);
			})
			.finally(() => setWait(false))
	}
}